import React, { Suspense } from 'react'

import { Route, Switch } from 'react-router-dom'

import { LayoutSplashScreen } from '_metronic'

import { PRODUCTOS_NUEVO, PRODUCTOS_LISTA } from 'constants/codigosTransacciones'

import ListaPage from './lista'
import NuevoActualizarPage from './nuevo-actualizar'

export default function ProductosPages() {
  return (
    <Suspense fallback={<LayoutSplashScreen />}>
      <Switch>
        <Route path={`/${PRODUCTOS_NUEVO}/:id`} component={NuevoActualizarPage} />
        <Route path={`/${PRODUCTOS_NUEVO}`} component={NuevoActualizarPage} />
        <Route path={`/${PRODUCTOS_LISTA}`} component={ListaPage} />
      </Switch>
    </Suspense>
  )
}
